import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const CustomerHeaderContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 140px;
  padding-top: 64px;
  padding-bottom: 20px;
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  margin-bottom: 24px;
`;

export const StyledGenderContainer = styled.div`
  position: absolute;
  width: 70px;
  height: 70px;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  padding: 8px;
  border-radius: 50%;
  left: 50%;
  top: 0;
  transform: translate(-50%, -35%);
`;

export const StyledGender = styled.div<{ sex: string }>`
  width: 100%;
  height: 100%;
  background-image: ${({ sex }): string =>
    !sex && 'linear-gradient(#d9d9d9, #298cff, #ff29a9)'};
  background-color: ${({ theme, sex }): string =>
    sex === 'Male'
      ? theme.colors.male
      : sex === 'Female'
      ? theme.colors.female
      : 'unset'};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDetails = styled(StyledDiv)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;

  :not(:last-of-type) {
    border-left: ${({ theme }): string => theme.borders[0]};
    border-color: ${({ theme }): string => theme.colors.border};
  }
`;
